export const btbTmcEn = [
  {
    title: (
      <h2 className="text-[#1B1D1F]  text-2xl font-bold leading-[30px] w-full text-start py-5">
        Regarding the Provision of Dynamic Invoice Creation and Virtual Asset
        Inter-exchange Services
      </h2>
    ),
    content: (
      <div>
        <span className="block">
          This document represents a binding legal agreement concluded between
          <strong>"WhiteBIT Georgia" LLC</strong> (ID: 405520217, hereinafter -
          <strong> "WhiteBIT"</strong> or <strong>"We"</strong>) and you, as the
          legal entity receiving the service (hereinafter -
          <strong>"Client"</strong> or <strong>"You"</strong>).
        </span>
        <br />
        <br />
        <h3 className="font-bold">WHEREAS: </h3>
        <br />
        <span className="font-bold pb-6">
          We are a virtual asset service provider, founded in accordance with
          the legislation of Georgia and registered by the National Bank of
          Georgia as a virtual asset service provider, with registration number:
          0007-9404;
        </span>
        <br />
        <span className="font-bold pb-6">
          We provide virtual asset services through this website:
          https://WhiteBIT.ge (hereinafter "Website" or "Platform”).
        </span>
        <br />
        <br />
        <span className="font-bold">
          We provide the service of creating dynamic invoices using Whitepay's
          software (hereinafter - "Whitepay Software") from the Whitepay
          platform: https://Whitepay.ge (hereinafter - "Whitepay Platform");
        </span>
        <br />
        <br />
        <span className="font-bold">
          You wish for WhiteBIT to conduct the inter-exchange of virtual assets
          and deposit funds for the Client, based on the data recorded in the
          dynamic invoice, in accordance with Order N94/04 of the President of
          the National Bank of Georgia dated June 13, 2023.
        </span>
        <br />
        <br />
        <span className="font-bold">
          You wish to receive the services of dynamic invoice creation and
          virtual asset inter-exchange from WhiteBIT for the above-mentioned
          purposes;
        </span>
        <br />
        <br />
        <span className="font-bold">
          Your registration on the Whitepay Platform, or clicking the "I agree"
          button on these terms and conditions, or commencing the use of the
          services, signifies your full and unconditional agreement to these
          terms and conditions, which constitute the main regulatory framework
          governing the use of WhiteBIT's platforms and the services defined by
          this Agreement.
        </span>
        <br />
        <br />
        <h2 className="font-bold my-6">1. Subject of the Service</h2>
        <span className="block">
          <strong>1.1.</strong> In accordance with these terms and conditions
          (hereinafter <strong> "Terms"</strong> or <strong>"Agreement"</strong>
          ), <strong>WhiteBIT</strong> shall provide the Client with the service
          of <strong>dynamic invoice creation</strong> through the
          <strong>Whitepay </strong>
          Platform and the service of
          <strong> virtual asset inter-exchange </strong>through the Websites.
        </span>
        <br />
        <span className="block">
          <strong>1.2.</strong> To provide the service,{" "}
          <strong>WhiteBIT</strong> grants the Client access to the{" "}
          <strong> Whitepay </strong>
          Platform, where the Client can generate/create dynamic invoices for
          their own customers to reimburse the cost of services rendered/to be
          rendered and/or goods transferred/to be transferred. The customer, in
          turn, can convert the virtual assets in their ownership into standard
          currency on the <strong>WhiteBIT</strong> Platform to pay the desired
          amount and transfer this amount to the Client’s bank account opened
          with the recipient provider/acquirer. Given this, the Parties agree as
          follows:
        </span>
        <br />
        <span className="block">
          <ul className="list-disc pl-6">
            <li>
              <strong>WhiteBIT</strong> shall only provide the Client with the
              service of <strong> generating dynamic invoices</strong> on the
              <strong> Whitepay</strong> Platform and the service of receiving
              funds through the inter-exchange of virtual assets, and only
              provide the Client's customer with the service of
              <strong>
                instant conversion of virtual assets into standard currency;
              </strong>
            </li>
            <li>
              <strong>WhiteBIT does not provide payment services</strong> to the
              Client or its customers. In order for a transaction to be executed
              based on a dynamic invoice created by the Client and for the
              Client to receive funds, after the instant conversion of the
              virtual asset into standard currency on the{" "}
              <strong>WhiteBIT</strong> Platform, the amount will be transferred
              to the Client's bank account based on the service of a payment
              service provider licensed/registered under the laws of Georgia.
              <strong>WhiteBIT</strong> shall ensure the involvement of this
              payment service provider in the process and the availability of
              its service.
            </li>
            <li>
              In order for <strong>WhiteBIT</strong> to provide the services
              defined by this Agreement to the Client, the Client is obliged to
              be registered as a <strong>verified user </strong>on both
              <strong> WhiteBIT</strong> platforms, in accordance with the
              regulations provided by Georgian legislation. Registration on the
              platforms is free, unless otherwise specified by the user
              agreements of the <strong>WhiteBIT</strong> platforms.
            </li>
            <li>
              The Client is obliged to ensure that their customer is informed
              about the necessity of establishing a business relationship with
              <strong> WhiteBIT </strong>and the payment service provider, as
              established under this Agreement.
            </li>
            <li>
              The Client is obliged to ensure the accessibility, accuracy, and
              completeness of the necessary information for generating invoices.
            </li>
          </ul>
        </span>
        <br />
        <h2 className="font-bold mb-6">
          2. Conditions for Service Provision and Client Obligations
        </h2>
        <div>
          <span className="block">
            <strong>2.1. WhiteBIT </strong>is obliged to provide the service to
            the Client only if the latter ensures the fulfillment of their
            contractual obligations, as well as all other relevant regulations
            and legal obligations, including the Law of Georgia "On Facilitating
            the Prevention of Money Laundering and the Financing of Terrorism"
            and Order No. 94/04 of the President of the National Bank of Georgia
            dated June 13, 2023, "On Approval of the Rules for Registration,
            Deregistration, and Regulation of a Virtual Asset Service Provider
            at the National Bank of Georgia."
          </span>
          <br />
          <span className="block">
            <strong>2.2.</strong> The Client is obliged to fully and accurately
            provide <strong> WhiteBIT</strong> with the information necessary
            for the provision of the service. The Client must also ensure that
            any information provided by them is error-free. WhiteBIT is not
            responsible for any damage or loss that may arise from the Client
            providing incorrect or incomplete information. Furthermore, the
            Client shall be solely responsible in the event that any claims,
            demands, or requests for damage compensation arise against
            <strong> WhiteBIT</strong> by third parties as a result of providing
            such information.
          </span>
          <br />
          <h2 className="font-bold my-3">
            3. Service Commission and Payment Terms
          </h2>
          <br />
          <span className="block">
            <strong>3.1.</strong> For the services rendered to the Client,
            commissions for the services of <strong>WhiteBIT</strong> and the
            payment service provider <strong>shall be added </strong> to the
            amount specified in the dynamic invoice, and these shall be paid by
            the Client or the Client's customer.
          </span>
          <br />
          <span className="block">
            <strong>3.2.</strong> The exact percentage amount of the commissions
            and the turnover limits
            <strong className="pl-1">
              are not established by these Terms and are regulated by a
              separate, individual written agreement between the Client and
              WhiteBIT.
            </strong>
          </span>
          <br />
          <span className="block">
            <strong>3.3. WhiteBIT </strong> has the right to periodically
            change, update, reduce, or increase the service commission. The
            Client shall be notified of the changes in advance,
            <strong>5 (five) calendar days </strong> prior, by written notice.
          </span>
          <br />
          <span className="block">
            <strong>3.4.</strong>
            The Client/Client's customer may additionally incur{" "}
            <strong> "Network Commission" </strong> expenses (miner fees, "gas
            fee," etc.), for which the Client/Client's customer shall be
            responsible.
          </span>
          <br />
          <span className="block">
            <strong>3.5.</strong>
            The Client is obliged to inform their customer about the payable
            commissions.
          </span>
          <br />
          <span className="block">
            <strong>3.6.</strong>
            If a transaction is canceled and a refund is required, the refund
            shall only be processed if the customer is registered on the
            <strong> WhiteBIT </strong>Platform. Furthermore, the refund{" "}
            <strong>
              shall only be made in the equivalent of the amount received in
              stable virtual assets (WBGEL, WBUSD, or WBEURO).
            </strong>
          </span>
          <br />
          <span className="block">
            <strong>3.7.</strong>
            The refund shall be processed only to the account of the customer
            registered on the <strong> WhiteBIT </strong>Platform, based on the
            Client's written request, following this procedure:
            <ul className="list-disc pl-6">
              <li>
                To initiate the refund process, the Client is obliged to notify
                <strong> WhiteBIT </strong> in writing about the refund to the
                customer, indicating the amount to be refunded and the
                customer's details. Following this, <strong> WhiteBIT </strong>
                will provide the Client with the bank/payment service provider
                account of <strong> WhiteBIT </strong> to which the amount to be
                refunded to the customer must be credited.
              </li>
              <li>
                Once <strong> WhiteBIT </strong> receives the amount to be
                refunded to the Client's customer in the agreed account,
                <strong> WhiteBIT </strong> shall ensure the conversion of the
                funds and the crediting of the amount to the customer's account
                registered on the Platform.
              </li>
              <li>
                The Client is obliged to inform their customer about the
                requirements/rules of refund specified in this article.
              </li>
            </ul>
          </span>
          <br />
          <span className="block">
            <strong>3.8. WhiteBIT is not responsible </strong>
            for any additional costs, claims, or demands associated with the
            refund process.
          </span>
        </div>
        <br />
        <h2 className="font-bold mt-6">
          4. Information Request and Suspicious Activity{" "}
        </h2>
        <br />
        <span className="block">
          <strong> 4.1. WhiteBIT </strong>
          has the right to request any information, document, and instruction
          from the Client for the provision of services, including{" "}
          <strong>KYB (Know Your Business)</strong> -related information, and to
          request that they refrain from and do not engage in any suspicious
          activity and comply with all applicable anti-money laundering and
          counter-terrorist financing laws and regulations, as well as the
          AML/CTF (Anti-Money Laundering/Counter-Terrorist Financing) policy.
        </span>
        <br />
        <span className="block">
          <strong>4.2.</strong>
          The Client is obliged to provide the requested information to
          <strong> WhiteBIT </strong>
          within the following deadlines:
          <ul className="list-disc pl-6">
            <li>
              Suspicious transaction and KYB-related information:
              <strong> Immediately</strong>, but no later than{" "}
              <strong> 1 (one) business day.</strong>
            </li>
            <li>
              Information arising from legislative regulations:
              <strong> Immediately</strong>, but no later than
              <strong> 2 (two) business days.</strong>
            </li>
            <li>
              Other information: No later than{" "}
              <strong>5 (five) business days.</strong>
            </li>
          </ul>
        </span>
        <br />
        <span className="block">
          <strong>4.3. WhiteBIT</strong> has the right, at its own discretion,
          to refuse the service (in full or in part), impose restrictions,
          freeze the asset/funds, suspend, or terminate the service if:
          <ul className="list-disc pl-6">
            <li>
              The Client has failed to fulfill the obligations defined in Clause
              4.2.
            </li>
            <li>For compliance with the law.</li>
            <li>
              Unusual/suspicious activity (as defined by the legislation of
              Georgia) is identified in the Client's operations.
            </li>
            <li>
              A criminal investigation has been initiated against the Client.
            </li>
            <li>
              Other cases defined in <strong>WhiteBIT's</strong> user agreement.
            </li>
          </ul>
        </span>
        <br />
        <span className="block">
          <strong>4.4.</strong> The terms{" "}
          <strong> "suspicious transactions"</strong> and{" "}
          <strong>"unusual/suspicious activity"</strong> shall be interpreted in
          accordance with the definition provided in the Law of Georgia "On
          Facilitating the Prevention of Money Laundering and the Financing of
          Terrorism."
        </span>
        <br />
        <span className="block">
          <strong>4.5. WhiteBIT</strong>
          <span>
            shall inform the Client in advance if a specific prerequisite has
            been identified that may lead to the
            <strong> suspension/termination of service provision</strong> to the
            Client.
          </span>
        </span>
        <br />
        <h2 className="font-bold my-6">
          5. Liability and Warranties. Force Majeure{" "}
        </h2>
        <br />
        <span className="block">
          <strong>5.1.</strong> The Client agrees that the Platform and services
          are provided on an <strong>"as is" </strong> and{" "}
          <strong>"as available"</strong> basis.
          <strong>WhiteBIT</strong> expressly disclaims all warranties,
          including those of merchantability and fitness for a particular
          purpose.
        </span>
        <br />
        <span className="block">
          <strong>5.2.</strong> Each Party shall be responsible{" "}
          <strong>
            for the full or partial non-fulfillment of the obligations{" "}
          </strong>
          undertaken by this Agreement.
        </span>
        <br />
        <span className="block">
          <strong>5.3. WhiteBIT</strong> is liable to the Client only if the
          damage is caused by
          <strong>
            WhiteBIT's intentional non-fulfillment of an obligation, negligence,
            or bad faith actions.
          </strong>
        </span>
        <br />
        <span className="block">
          <strong>5.4. WhiteBIT</strong> is not responsible for:
          <ul className="list-disc pl-6">
            <li>Indirect damages, including lost revenue.</li>
            <li>
              Consequences caused by the actions of intermediary banks, payment
              providers, or other third parties.
            </li>
            <li>Changes in the exchange rate of virtual currency.</li>
            <li>
              Damage caused by the insecurity of the Client's access to the
              Platform (e.g., leakage of username/password).
            </li>
          </ul>
        </span>
        <br />
        <span className="block">
          <strong>5.5.</strong> The Client is responsible for taking all
          measures to ensure that their access to the Platform is secure
          (cybersecurity, antivirus, etc.). <strong>WhiteBIT</strong> shall not
          be liable for any damage suffered by the Client in case of a breach of
          the obligation undertaken in this article.
        </span>
        <br />
        <span className="block">
          <strong>5.6. WhiteBIT </strong> is responsible
          <strong> only for the part of the transaction</strong> that includes
          the conversion of the virtual asset credited based on the dynamic
          invoice and the instant transfer of the received standard currency to
          the Client's bank account.
        </span>
        <br />
        <span className="block">
          <strong>5.7.</strong> The Client is obliged to ensure the protection
          of its customer's rights in accordance with the legislation of
          Georgia. <strong>WhiteBIT </strong> is not responsible for the damage
          incurred by the customer as a result of the Client's violation of this
          obligation.
        </span>
        <br />
        <span className="block">
          <strong>5.8.</strong> Each party is released from liability for the
          full or partial non-fulfillment of the obligations undertaken by this
          Agreement if the non-fulfillment of the obligations is caused by
          insurmountable force (Force Majeure circumstances) or the fault of the
          other party.
        </span>
        <br />
        <span className="block">
          <strong>5.9.</strong> "Force Majeure" for the purposes of this
          Agreement means an event that is not under the control of either
          party, the development of which cannot be foreseen, avoided, or
          overcome with reasonable caution, and which objectively makes the
          fulfillment of the obligation impossible. Typical cases of Force
          Majeure include the following (non-exhaustive list):
        </span>
        <br />
        <span className="block">
          <strong>5.9.1. Natural Disasters: </strong> Earthquake, flood, fire,
          storm, landslide, and other natural disasters.
        </span>
        <br />
        <span className="block">
          <strong>5.9.2.</strong> War, terrorist act, revolution, civil unrest,
          insurrection, embargo, sanctions, changes in legislation, decisions
          adopted by state bodies that directly affect the functioning of the
          Platform or the circulation of virtual assets.
        </span>
        <br />
        <span className="block">
          <strong>5.9.3. Technological Events: </strong>
          <ul className="list-disc pl-6 pb-3">
            <li>
              <strong> Blockchain Network Failure:</strong> Large-scale
              malfunction, suspension, attack (e.g., 51% attack), or fundamental
              change (e.g., failed hard fork) of the blockchain network on which
              the virtual assets supported by the Platform are based, which is
              not caused by the Platform's direct fault.
            </li>
            <li>
              <strong> Obsolescence of Cryptographic Algorithms: </strong>
              Unplanned and unforeseen events that cause the used cryptographic
              algorithms to become vulnerable or obsolete, posing a threat to
              the security of assets.
            </li>
            <li>
              <strong> Cyberattacks: </strong>
              Large-scale and malicious cyberattacks (e.g., DDoS attack,
              widespread distribution of malware, critical infrastructure
              collapse) aimed at paralyzing the operation of the Platform or its
              core services and not caused by a gross violation of the
              Platform's security protocols.
            </li>
            <li>
              <strong className="pr-1">
                Global Internet or Communication Infrastructure Outage:
              </strong>
              Large-scale, unpredictable, and prolonged outage of the Internet
              or main communication channels.
            </li>
            <li>
              <strong>Financial Market Collapse: </strong>
              Sudden and large-scale collapse of global or regional financial
              markets that directly affects the Platform's liquidity or
              operational capabilities and is not caused by the Platform's
              management decisions.
            </li>
          </ul>
        </span>
        <br />
        <span className="block">
          <strong>5.10.</strong>
          The party for whom the fulfillment of an obligation has become
          impossible due to Force Majeure circumstances is obliged to
          immediately notify the other party in writing about these
          circumstances and their expected duration and take all reasonable
          measures to reduce the consequences of the Force Majeure circumstances
          and fulfill the obligations as soon as possible.
        </span>
        <br />
        <span className="block">
          <strong>5.11.</strong>
          During the existence of Force Majeure circumstances, the term for the
          fulfillment of obligations of the party affected by these
          circumstances shall be postponed by a period corresponding to the
          duration of these circumstances. If Force Majeure circumstances
          continue for more than 14 (fourteen) calendar days, either party shall
          have the right to terminate this Agreement by sending a written notice
          to the other party. In this case, neither party shall be held liable
          for damages caused by the termination of the Agreement.
        </span>
        <h2 className="font-bold my-6">6. Term and Termination </h2>
        <br />
        <span className="block">
          <strong>6.1.</strong>This Agreement enters into force from the moment
          of your <strong> acceptance (Click-Through) </strong> and is valid for
          an <strong> indefinite period </strong> until it is terminated in
          accordance with these Terms.
        </span>
        <br />
        <span className="block">
          <strong>6.2.</strong>Grounds for Termination:
          <ul className="list-disc pl-6">
            <li>
              Immediately, if one of the parties breaches an undertaken
              obligation.
            </li>
            <li>
              Unilaterally by <strong>WhiteBIT</strong>,immediately, in
              accordance with the rule defined in Clause 4.3 of this Agreement.
            </li>
            <li>
              Unilaterally, by sending a written notice to the other party 30
              (thirty) calendar days in advance.
            </li>
            <li>By mutual written agreement of the parties.</li>
          </ul>
        </span>
        <h2 className="font-bold my-6">
          7. Confidentiality, Personal Data, and Intellectual Property{" "}
        </h2>
        <br />
        <span className="block">
          <strong>7.1.</strong>
          The parties are obliged to protect the confidential information
          disclosed within the framework of these Terms, which obligation
          continues indefinitely even after the termination of this Agreement.
        </span>
        <br />
        <span className="block">
          <strong>7.2.</strong>
          Confidential information is considered to be any non-public
          information, including (but not limited to) ideas, plans, strategies,
          know-how, trade secrets, and intellectual property objects.
        </span>
        <br />
        <span className="block">
          <strong>7.3.</strong>
          The receiving party is obliged not to use or transfer confidential
          information to third parties without the prior written consent of the
          disclosing party.
        </span>
        <br />
        <span className="block">
          <strong className="">7.4.</strong>
          The Client understands that the use of the <strong>Whitepay </strong>
          Software does not imply the transfer of any rights thereto. The Client
          is obliged not to modify, decompile, create derivative programs,
          upload malicious software, or bypass security scopes of the software.
        </span>
        <br />
        <span className="block">
          <strong>7.5.</strong>
          The Client agrees that <strong> WhiteBIT </strong>may disclose
          their/their employees'/customers' personal data only as required by
          law or when necessary for the provision of the service.
        </span>
        <h2 className="font-bold my-6">
          8. Governing Law and Dispute Resolution{" "}
        </h2>
        <br />
        <span className="block">
          <strong>8.1.</strong>
          This Agreement shall be governed by and interpreted in accordance with
          the <strong>legislation of Georgia</strong>.
        </span>
        <br />
        <span className="block">
          <strong>8.2.</strong>
          The parties shall attempt to resolve disputes
          <strong> through negotiations.</strong> If a dispute cannot be
          resolved within 30 days from its occurrence, it shall be submitted for
          consideration to the <strong> Tbilisi City Court.</strong>
        </span>
        <h2 className="font-bold my-6">9. Additional Rules </h2>
        <span className="block">
          <strong>9.1.</strong>
          This Agreement reflects the main agreement regarding the provision of
          dynamic invoice creation and virtual asset inter-exchange services.
          Any issue not regulated by this document shall be regulated by the
          <strong> WhiteBIT</strong> User Agreement
          <strong> (https://WhiteBIT.ge/terms) </strong>
          and the <strong> Whitepay</strong> Terms and Conditions
          <strong> (https://Whitepay.ge/terms)</strong>.
        </span>
        <br />
        <span className="block">
          <strong>9.2.</strong>
          The Client agrees that <strong> WhiteBIT</strong> is authorized to
          mention the Client in marketing activities and use its logo/name
          solely for informational purposes.
        </span>
        <br />
        <span className="block">
          <strong>9.3.</strong>
          All official notifications must be in written form.
          <strong> WhiteBIT's </strong>
          official email address is: <strong>legal@WhiteBIT.ge. </strong> The
          Client's email address shall be the one provided during their
          registration.
        </span>
        <br />
        <span className="block">
          <strong>9.4.</strong>
          Changes to these Terms shall enter into force from the moment of their
          publication by <strong>WhiteBIT </strong> on the Platform.
        </span>
      </div>
    ),
  },
];

export const btbTmcGe = [
  {
    title: (
      <h2 className="text-[#1B1D1F] text-2xl font-bold leading-[30px] w-full text-center py-5">
        დინამიური ინვოისების შექმნისა და ვირტუალური აქტივების ურთიერთგადაცვლის
        მომსახურების გაწევის თაობაზე
      </h2>
    ),
    content: (
      <div>
        <span className="block">
          ეს დოკუმენტი წარმოადგენს შპს <strong> „ვაითბით ჯორჯია“-ს </strong>
          (ს/კ: 405520217, შემდგომში -<strong> „WhiteBIT“ </strong> ან
          <strong> „ჩვენ“</strong>) და თქვენ, როგორც მომსახურების მიმღებ
          იურიდიულ პირს (შემდგომში -<strong> „კლიენტი“</strong> ან{" "}
          <strong>„თქვენ“</strong>) შორის დადებულ სავალდებულო იურიდიულ
          შეთანხმებას.
        </span>

        <h2 className="font-bold my-6">იქიდან გამომდინარე, რომ:</h2>

        <strong className="block">
          ჩვენ წარმოვადგენთ ვირტუალური აქტივების მომსახურების პროვაიდერს,
          რომელიც დაფუძნებულია საქართველოს კანონმდებლობის შესაბამისად და
          საქართველოს ეროვნული ბანკის მიერ რეგისტრირებულია როგორც ვირტუალური
          აქტივების მომსახურების პროვაიდერი, რეგისტრაციის ნომრით: 0007-9404;
        </strong>
        <br />
        <strong className="block">
          ჩვენ ვირტუალური აქტივების მომსახურების გაწევას ვახდენთ ამ
          ვებგვერდიდან: https://WhiteBIT.ge (შემდგომში „ვებგვერდი“ ან
          „პლატფორმა“);
        </strong>
        <br />
        <strong className="block">
          ჩვენ დინამიური ინვოისების შექმნის - Whitepay-ს პროგრამული
          უზრუნველყოფით (შემდგომში - "Whitepay პროგრამული უზრუნველყოფა")
          მომსახურებას ეწევა Whitepay-ს პლატფორმიდან - https://Whitepay.ge
          (შემდგომში - “Whitepay-ს პლატფორმა”);
        </strong>
        <br />
        <strong className="block">
          თქვენ გსურთ, რომ WhiteBIT-მა დინამიური ინვოისში დაფიქსირებული
          მონაცემებით განახორციელოს ვირტუალური აქტივის ურთიერთგადაცვლა და
          კლიენტისთვის ფულადი სახსრების ჩარიცხვა, საქართველოს ეროვნული ბანკის
          პრეზიდენტის 2023 წლის 13 ივნისის N94/04 ბრძანების შესაბამისად.
        </strong>
        <br />
        <strong className="block">
          თქვენ გსურთ, რომ ზემოაღნიშნული მიზნებისთვის WhiteBIT-ისაგან მიიღოს
          დინამიური ინვოისების შექმნისა და ვირტუალური აქტივების ურთიერთგადაცვლის
          მომსახურება;
        </strong>
        <br />
        <br />
        <span className="block">
          თქვენს მიერ <strong> Whitepay</strong> პლატფორმაზე რეგისტრაცია, ან ამ
          წესებსა და პირობებზე <strong> „ვეთანხმები“</strong> ღილაკზე დაჭერა ან
          მომსახურებით სარგებლობის დაწყება ნიშნავს, რომ თქვენ
          <strong> სრულად და უპირობოდ ეთანხმებით </strong> ამ წესებსა და
          პირობებს, რომლებიც წარმოადგენს <strong> WhiteBIT-ის </strong>{" "}
          პლატფორმებითა და წინამდებარე შეთანხმებით განსაზღვრული მომსახურებით
          სარგებლობის ძირითად, მარეგულირებელ ჩარჩოს.
        </span>

        <h2 className="font-bold my-6">1. მომსახურების საგანი</h2>

        <span className="block">
          <strong>1.1.</strong> წინამდებარე წესების და პირობების (შემდგომში
          <strong> “წესები”</strong> ან <strong>“შეთანხმება”</strong>)
          შესაბამისად,<strong> WhiteBIT</strong>კლიენტს, Whitepay-ს პლატფორმის
          მეშვეობით, გადასცემს დინამიური ინვოისების შექმნის, ხოლო ვებგვერდების
          მეშვეობით, გადასცემს ვირტუალური აქტივების ურთიერთგადაცვლის
          მომსახურებას.
        </span>
        <br />
        <span className="block">
          <strong>1.2.</strong> მომსახურების გასაწევად,{" "}
          <strong> WhiteBIT</strong> კლიენტს გადასცემს <strong>Whitepay</strong>{" "}
          -ს პლატფორმაზე წვდომას, სადაც კლიენტი შეძლებს, საკუთარი
          მომხმარებლებისათვის დააგენერიროს/შექმნას დინამიური ინვოისები
          გაწეული/გასაწევი მომსახურების ან/და გადაცემული/გადასაცემი საქონლის
          ღირებულების ასანაზღაურებლად, ხოლო მომხმარებელი შეძლებს, სასურველი
          თანხის გადასახდელად მოახდინოს მის საკუთრებაში არსებული ვირტუალური
          აქტივების სტანდარტულ ვალუტაში კონვერტაცია <strong> WhiteBIT</strong>
          -ის პლატფორმაზე და აღნიშნული თანხის გადარიცხვა მიმღების
          პროვაიდერთან/ექვაირერთან გახსნილ კლიენტის საბანკო ანგარიშზე. ამის
          გათვალისწინებით, მხარეები თანხმდებიან შემდეგზე:
        </span>
        <ul className="list-disc pl-6 pt-3">
          <li>
            <strong> WhiteBIT</strong> კლიენტს გაუწევს მხოლოდ{" "}
            <strong>Whitepay</strong>
            -ს პლატფორმაზე დინამიური ინვოისის გენერირების და ვირტუალური
            აქტივების ურთიერთგადაცვლით ფულადი სახსრების მიღების მომსახურებას,
            ხოლო კლიენტის მომხმარებელს - მხოლოდ ვირტუალური აქტივების სტანდარტულ
            ვალუტაში <strong>მყისიერი</strong> კონვერტაციის მომსახურებას;
          </li>
          <li>
            <strong> WhiteBIT არ აწვდის </strong>კლიენტს ან მის მომხმარებელს
            საგადახდო მომსახურებას. იმისათვის რათა კლიენტის მიერ შექმნილი
            დინამიური ინვოისის საფუძველზე განხორციელდეს ტრანზაქცია და კლიენტმა
            შეძლოს ფულადი სახსრების მიღება, <strong> WhiteBIT</strong>-ის
            პლატფორმაზე ვირტუალური აქტივის სტანდარტულ ვალუტაში მყისიერი
            კონვერტაციის შემდეგ, თანხა კლიენტის საბანკო ანგარიშზე გადაირიცხება
            საქართველოს კანონმდებლობის საფუძველზე ლიცენზირებული/რეგისტრირებული
            საგადახდო მომსახურების პროვაიდერის მომსახურების საფუძველზე.
            აღნიშნული საგადახდო მომსახურების პროვაიდერის პროცესში ჩართულობას და
            მომსახურების ხელმისაწვდომობას უზრუნველყოფს <strong>WhiteBIT</strong>
            .
          </li>
          <li>
            იმისათვის, რათა შესაძლებელი იყოს წინამდებარე ხელშეკრულებით
            განსაზღვრული მომსახურების გაწევა კლიენტისათვის, კლიენტი ვალდებულია,
            საქართველოს კანონმდებლობით გათვალისწინებული რეგულაციების
            შესაბამისად, იყოს დარეგისტრირებული როგორც ვერიფიცირებული
            მომხმარებელი <strong> WhiteBIT </strong>-ის ორივე პლატფორმაზე.
            პლატფორმებზე რეგისტრაცია უფასოა, თუ სხვაგვარად არ არის განმარტებული
            <strong> WhiteBIT</strong>-ის პლატფორმების სამომხმარებლო
            შეთანხმებების მიხედვით.
          </li>
          <li>
            კლიენტი ვალდებულია უზურნველყოს საკუთარი მომხმარებლის ინფორმირებულობა
            წინამდებარე ხელშკერულების საფუძველზე დადგენილი
            <strong> WhiteBIT</strong>-სა და საგადადო მომსახურების პროვაიდერთან
            საქმიანი ურთიერთობის დამყარების საჭიროებაზე.
          </li>
          <li>
            კლიენტი ვალდებულია უზრუნველყოს ინვოისების დასაგენერირებლად საჭირო
            ინფორმაციის ხელმისაწვდომობა, სიზუსტე და სისრულე;
          </li>
        </ul>
        <h2 className="font-bold my-6">
          2. მომსახურების გაწევის პირობები და კლიენტის ვალდებულებები{" "}
        </h2>
        <span className="block">
          <strong>2.1 WhiteBIT</strong> მხოლოდ იმ შემთხვევაშია ვალდებული
          მომსახურება გაუწიოს კლიენტს, თუ ეს უკანსაკნელი უზრუნველყოფს მის მიერ
          ნაკისრი სახელშეკრულებო ვალდებულებების და ასევე - ყველა სხვა
          რელევანტური რეგულაციასა და სამართლებრივი ვალდებულების შესრულებას, მათ
          შორის „ფულის გათეთრებისა და ტერორიზმის დაფინანსების აღკვეთის
          ხელშეწყობის შესახებ“ საქართველოს კანონის და “ვირტუალური აქტივის
          მომსახურების პროვაიდერის საქართველოს ეროვნულ ბანკში რეგისტრაციის,
          რეგისტრაციის გაუქმებისა და რეგულირების წესის დამტკიცების თაობაზე"
          საქართველოს ეროვნული ბანკის პრეზიდენტის 2023 წლის 13 ივნისის №94/04
          ბრძანების შესრულებას.
        </span>
        <span className="block">
          <strong>2.2</strong> კლიენტი ვალდებულია, სრულად და ზუსტად მიაწოდოს
          <strong> WhiteBIT</strong>-ს ის ინფორმაცია, რომელიც საჭიროა
          მომსახურების გასაწევად. კლიენტმა ასევე უნდა უზრუნველყოს, რომ მის მიერ
          მიწოდებული ნებისმიერი ინფორმაცია იყოს უშეცდომო.
          <strong> WhiteBIT</strong> არ არის პასუხისმგებელი რაიმე სახის ზიანზე
          ან დანაკარგზე, რომელიც შეიძლება წარმოიშვას კლიენტის მიერ მისთვის
          არასწორი ან არასრულყოფილი ინფორმაციის მიწოდებით. ამასთან, კლიენტი
          იქნება სრულად პასუხისმგებელი იმ შემთხევვაში, თუ ასეთი ინფორმაციის
          მიწოდების შედეგად მესამე პირებს
          <strong> WhiteBIT</strong>-ის მიმართ წარმოეშვებათ ნებისმიერი
          პრეტენზია, მოთხოვნა, ზიანის ანაზღაურების მოთხოვნა.
        </span>

        <h2 className="font-bold my-6">
          3. მომსახურების საკომისიო და გადახდის პირობები
        </h2>

        <span className="block">
          <strong>3.1.</strong> კლიენტისთვის გაწეული მომსახურებისათვის,
          დინამიური ინვოისით განსაზღვრულ თანხას
          <strong> დაემატება საკომისიოები WhiteBIT</strong>-ის და საგადახდო
          მომსახურების პროვაიდერის მომსახურებებისთვის, რომელსაც გადაიხდის
          კლიენტი ან კლიენტის მომხმარებელი.
        </span>
        <br />
        <span className="block">
          <strong>3.2.</strong> საკომისიოების ზუსტი პროცენტული ოდენობა და
          ბრუნვის ლიმიტები <strong>არ არის დადგენილი</strong> ამ წესებით და
          <strong className="px-1">
            რეგულირდება ცალკეული, ინდივიდუალური წერილობითი შეთანხმებით
          </strong>
          კლიენტსა და <strong> WhiteBIT</strong>-ს შორის.
        </span>
        <br />
        <span className="block">
          <strong>3.3. WhiteBIT</strong>-ს უფლება აქვს, პერიოდულად შეცვალოს,
          განაახლოს, შეამციროს ან გაზარდოს მომსახურების საკომისიო. ცვლილებების
          შესახებ კლიენტს ეცნობება წინასწარ,{" "}
          <strong>5 (ხუთი) კალენდარული დღით ადრე </strong>
          წერილობითი შეტყობინებით.
        </span>
        <br />
        <span className="block">
          3.4. კლიენტს/კლიენტის მომხმარებელს შესაძლოა დამატებით წარმოეშვას
          <strong> „ქსელის საკომისიოების“</strong> (მაინერების საკომისიო, "gas
          fee" და სხვ.) ხარჯები, რაზეც პასუხისმგებლობა ეკისრება კლიენტს/კლიენტის
          მომხმარებელს.
        </span>
        <br />
        <span className="block">
          3.5. კლიენტი ვალდებულია მოახდინოს საკუთარი მომხმარებლის ინფორმირება
          გადასახდელი საკომისიოების თაობაზე.
        </span>
        <br />
        <span className="block">
          3.6. თუ ტრანზაქცია გაუქმდება და საჭირო გახდება თანხის დაბრუნება,
          დაბრუნება განხორციელდება <strong>მხოლოდ </strong>იმ შემთხვევაში, თუ
          მომხმარებელი რეგისტრირებულია <strong> WhiteBIT</strong>-ის
          პლატფორმაზე. ამასთან, დაბრუნება ხდება
          <strong className="px-1">
            მხოლოდ სტაბილური ვირტუალური აქტივების სახით (WBGEL, WBUSD ან WBEURO)
          </strong>
          მიღებული თანხის ეკვივალენტში.
        </span>
        <br />
        <br />
        <span className="block">
          3.7. დაბრუნება განხორციელდება მხოლოდ <strong>WhiteBIT</strong>-ის
          პლატფორმაზე რეგისტრირებული მომხმარებლის ანგარიშზე, კლიენტის წერილობითი
          მოთხოვნის საფუძველზე, შემდეგი პროცედურის დაცვით:
        </span>
        <ul className="list-disc pl-6 pt-4">
          <li>
            დაბრუნების პროცესის დასაწყებად, კლიენტი ვალდებულია
            <strong> WhiteBIT</strong>-ს წერილობით შეატყობინოს მომხმარებლისათვის
            თანხის დაბრუნების თაობაზე და მიუთითოს დასაბრუნებელი თანხის ოდენობა
            და მომხმარებლის რეკვიზიტები რის შემდეგაც,<strong> WhiteBIT </strong>
            მიაწვდის კლიენტს <strong>WhiteBIT</strong>-ის საბანკო/საგადახდო
            მომსახურების პროვაიდერის ანგარიშს, რომელზეც უნდა დაერიცხოს
            მომხმარებლისათვის დასაბრუნებელი თანხა.
          </li>
          <li>
            მას შემდეგ, რაც <strong> WhiteBIT</strong>-ს, შეთანხმებულ ანგარიშზე
            დაერიცხება კლიენტის მომხმარებელისათვის დასაბრუნებელი თანხა,
            <strong> WhiteBIT</strong>
            უზრუნველყოფს თანხის კონვერტაციას და კლიენტის მომხმარებლის
            პლატფორმაზე რეგისტრირებულ ანგარიშზე დარიცხვას.
          </li>
          <li>
            კლიენტი ვალდებულია, შეატყობინოს მის მომხმარებელს წინამდებარე მუხლში
            აღნიშნული მოთხოვნების/დაბრუნების წესის თაობაზე.
          </li>
        </ul>
        <br />
        <span className="block">
          3.8. <strong> WhiteBIT არ არის პასუხისმგებელი </strong> დაბრუნების
          პროცესთან დაკავშირებულ ნებისმიერ დამატებით ხარჯზე, პრეტენზიაზე ან
          მოთხოვნაზე.
        </span>

        <h2 className="font-bold my-6">
          4. ინფორმაციის გამოთხოვა და საეჭვო საქმიანობა
        </h2>
        <span className="block">
          4.1. <strong>WhiteBIT</strong>-ს უფლება აქვს, მოითხოვოს ნებისმიერი
          ინფორმაცია, დოკუმენტი და ინსტრუქცია კლიენტისგან მომსახურების
          გაწევისთვის, მათ შორის <strong> KYB (Know Your Business)</strong>-თან
          დაკავშირებული ინფორმაცია, და მოითხოვოს რომ თავი შეიკავოს და არ
          განახორციელოს ნებისმიერი საეჭვო საქმიანობა და შეასრულოს ყველა მოქმედი
          ფულის გათეთრების და ტერორიზმის დაფინანსების საწინააღმდეგო
          კანონმდებლობა და რეგულაციები, აგრეთვე AML/CTF (ფულის გათეთრების
          საწინააღმდეგო/ტერორიზმის დაფინანსების) პოლიტიკა.
        </span>
        <br />
        <span className="block">
          4.2. კლიენტი ვალდებულია მოთხოვნილი ინფორმაცია მიაწოდოს
          <strong> WhiteBIT</strong>-ს შემდეგ ვადებში:
        </span>
        <span className="block">
          * საეჭვო ტრანზაქციების და KYB-თან დაკავშირებული ინფორმაცია:
          <strong> დაუყოვნებლივ</strong>, თუმცა არაუგვიანეს
          <strong> 1 (ერთი) სამუშაო დღისა.</strong>
        </span>
        <span className="block">
          * საკანონმდებლო რეგულაციებიდან გამომდინარე ინფორმაცია:
          <strong> დაუყოვნებლივ</strong>, თუმცა არაუგვიანეს
          <strong> 2 (ორი) სამუშაო დღისა.</strong>
        </span>
        <span className="block">
          * სხვა ინფორმაცია: არაუგვიანეს <strong> 5 (ხუთი) სამუშაო დღე.</strong>
        </span>
        <br />
        <span className="block">
          4.3.<strong> WhiteBIT</strong>-ს უფლება აქვს, საკუთარი განკარგულებით,
          <strong> უარი თქვას მომსახურებაზე</strong> (სრულად ან ნაწილობრივ),
          დააწესოს შეზღუდვები, გაყინოს აქტივი/ფულადი სახსრები, შეაჩეროს ან
          შეწყვიტოს მომსახურება, თუ:
        </span>
        <span className="block">
          * კლიენტმა ვერ შეასრულა 4.2 პუნქტით განსაზღვრული ვალდებულებები.
        </span>
        <span className="block">* კანონმდებლობასთან შესაბამისობისთვის.</span>
        <span className="block">
          * კლიენტის საქმიანობაში გამოვლინდა უჩვეულო/საეჭვო საქმიანობა (როგორც
          განმარტებულია საქართველოს კანონმდებლობით).
        </span>
        <span className="block">
          * კლიენტის მიმართ დაწყებულია სისხლის სამართლის მოკვლევა.
        </span>
        <span className="block">
          * სხვა შემთხვევები, რომლებიც განსაზღვრულია <strong> WhiteBIT</strong>
          -ის მომხმარებლის შეთანხმებაში.
        </span>
        <br />
        <span className="block">
          4.4. ტერმინები <strong>“საეჭვო ტრანზაქციები”</strong> და
          <strong> “უჩვეულო/საეჭვო საქმიანობა”</strong> განიმარტება „ფულის
          გათეთრებისა და ტერორიზმის დაფინანსების აღკვეთის ხელშეწყობის შესახებ“
          საქართველოს კანონში მოცემული განმარტების შესაბამისად.
        </span>
        <br />
        <span className="block">
          4.5. <strong> WhiteBIT</strong> წინასწარ ატყობინებს კლიენტს იმის
          თაობაზე, რომ გამოვლენილია კონკრეტული წინაპირობა, რომლის შედეგადაც
          შეიძლება კლიენტს
          <strong> შეუჩერდეს/შეუწყდეს მომსახურების გაწევა.</strong>
        </span>
        <h2 className="font-bold my-6">
          5. პასუხისმგებლობა და გარანტიები. ფორს-მაჟორი
        </h2>
        <span className="block">
          5.1. კლიენტი ეთანხმება, რომ პლატფორმა და მომსახურებები მოწოდებულია
          პრინციპით <strong> „როგორც არის“</strong> და
          <strong> „როგორც ხელმისაწვდომია“. WhiteBIT </strong> პირდაპირ უარს
          აცხადებს ყველა სახის გარანტიაზე, მათ შორის კომერციული სარგებლიანობისა
          და კონკრეტული მიზნისთვის ვარგისიანობის შესახებ.
        </span>
        <br />
        <span className="block">
          5.2. თითოეული მხარე პასუხს აგებს ამ ხელშეკრულებით ნაკისრი
          ვალდებულებების
          <strong> მთლიანად ან ნაწილობრივ შეუსრულებლობისათვის.</strong>
        </span>
        <br />
        <span className="block">
          5.3. <strong> WhiteBIT </strong> პასუხისმგებელია კლიენტის წინაშე
          მხოლოდ იმ შემთხვევაში, თუ ზარალი გამოწვეულია{" "}
          <strong>WhiteBIT </strong>
          -ის მიერ
          <strong className="px-1">
            ვალდებულების განზრახ შეუსრულებლობით, გაუფრთხილებლობით ან
            არაკეთილსინდისიერი ქმედებებით
          </strong>
        </span>
        <br />
        <span className="block">
          5.4. <strong> WhiteBIT </strong> არ არის პასუხისმგებელი:
          <br />
          <br />
          <span className="block">
            * არაპირდაპირ ზარალზე, მათ შორის მიუღებელ შემოსავალზე.
          </span>
          <br />
          <span className="block">
            * შუამავალი ბანკების, საგადახდო პროვაიდერების ან სხვა მესამე პირების
            ქმედებებით გამოწვეულ შედეგებზე.
          </span>
          <br />
          <span className="block">
            * ვირტუალური ვალუტის გაცვლის კურსში მომხდარ ცვლილებებზე.
          </span>
          <br />
          <span className="block">
            * კლიენტის მიერ პლატფორმაზე წვდომის დაუცველობით (მაგ.,
            მომხმარებლის/პაროლის გაჟონვა) მიყენებულ ზიანზე.
          </span>
          <br />
        </span>
        <span className="block">
          5.5. კლიენტი პასუხისმგებელია მიიღოს ყველა ზომა, რომ მისი წვდომა
          პლატფორმაზე იყოს დაცული (კიბერუსაფრთხოება, ანტივირუსი და სხვ.).
          <strong> WhiteBIT</strong> პასუხს არ აგებს ნებისმიერ ზიანზე, რომელიც
          კლიენტს მიადგება წინამდებარე მუხლში ნაკისრი ვალდებულების დარღვევის
          შემთხვევაში.
        </span>
        <br />
        <span className="block">
          5.6.<strong> WhiteBIT</strong> პასუხისმგებელია ტრანზაქციის
          <strong> მხოლოდ იმ ნაწილზე</strong>, რომელიც მოიცავს დინამიური
          ინვოისის საფუძველზე დარიცხული ვირტუალური აქტივის კონვერტაციას და
          მიღებული სტანდარტული ვალუტის მყისიერ გადარიცხვას კლიენტის საბანკო
          ანგარიშზე.
        </span>
        <br />
        <span className="block">
          5.7. კლიენტი ვალდებულია უზრუნველყოს საკუთარი მომხმარებლის უფლებების
          დაცვა საქართველოს კანონმდებლობის შესაბამისად.
          <strong> WhiteBIT </strong>
          არ არის პასუხისმგებელი კლიენტის მიერ ამ ვალდებულების დარღვევის შედეგად
          მომხმარებლისთვის დამდგარ ზიანზე.
        </span>
        <br />
        <span className="block">
          5.8. თითოეული მხარე ამ ხელშეკრულებით ნაკისრი ვალდებულებების მთლიანად
          ან ნაწილობრივ შეუსრულებლობის გამო პასუხისმგებლობისგან თავისუფლდება, თუ
          ვალდებულებების შეუსრულებლობა გამოწვეულია დაუძლეველი ძალის
          (ფორს-მაჟორული გარემოებების) ან მეორე მხარის ბრალის შედეგად.
        </span>
        <br />
        <span className="block">
          5.9. „ფორს-მაჟორი“ ამ ხელშეკრულების მიზნებისთვის ნიშნავს მოვლენას,
          რომელიც არ არის რომელიმე მხარის კონტროლის ქვეშ, რომლის განვითარება
          შეუძლებელია გონივრული სიფრთხილით განჭვრეტა, თავიდან აცილება ან
          გადალახვა და რომელიც ობიექტურად შეუძლებელს ხდის ვალდებულების
          შესრულებას. ფორს-მაჟორის ტიპური შემთხვევები მოიცავს შემდეგს (არა
          ამომწურავი ჩამონათვალი):
        </span>
        <br />
        <span className="block">
          5.9.1 <strong>სტიქიური უბედურებები: </strong>
          <br />
          <br />
          მიწისძვრა, წყალდიდობა, ხანძარი, ქარიშხალი, მეწყერი და სხვა ბუნებრივი
          კატასტროფები.
        </span>
        <br />
        <span className="block">
          5.9.2 ომი, ტერორისტული აქტი, რევოლუცია, სამოქალაქო არეულობა, აჯანყება,
          ემბარგო, სანქციები, კანონმდებლობის ცვლილებები, სახელმწიფო ორგანოების
          მიერ მიღებული გადაწყვეტილებები, რომლებიც პირდაპირ გავლენას ახდენს
          პლატფორმის ფუნქციონირებაზე ან ვირტუალური აქტივების მიმოქცევაზე.
        </span>
        <br />
        <span className="block">
          5.9.3 <strong>ტექნოლოგიური მოვლენები: </strong>
          <br />
          <br />
          <span className="block">
            <strong> ბლოკჩეინის ქსელის უკმარისობა: </strong> ბლოკჩეინის ქსელის,
            რომელზეც დაფუძნებულია პლატფორმის მიერ მხარდაჭერილი ვირტუალური
            აქტივები, მასშტაბური გაუმართაობა, შეჩერება, შეტევა (მაგ., 51%
            შეტევა) ან ფუნდამენტური ცვლილება (მაგ., წარუმატებელი ჰარდ-ფორკი),
            რომელიც არ არის გამოწვეული პლატფორმის პირდაპირი ბრალით.
          </span>
          <br />
          <ul className="list-disc pl-6">
            <li className="mb-3">
              <strong>კრიპტოგრაფიული ალგორითმების მოძველება:</strong>
              დაუგეგმავი და გაუთვალისწინებელი მოვლენები, რომლებიც იწვევს
              გამოყენებული კრიპტოგრაფიული ალგორითმების დაუცველობას ან
              მოძველებას, რაც საფრთხეს უქმნის აქტივების უსაფრთხოებას.
            </li>
            <li className="mb-3">
              <strong>კიბერთავდასხმები:</strong> მასშტაბური და მავნე
              კიბერთავდასხმები (მაგ., DDoS შეტევა, მავნე პროგრამების (malware)
              ფართომასშტაბიანი გავრცელება, კრიტიკული ინფრასტრუქტურის კოლაფსი),
              რომლებიც მიზნად ისახავს პლატფორმის ან მისი ძირითადი სერვისების
              მუშაობის პარალიზებას და არ არის გამოწვეული პლატფორმის უსაფრთხოების
              პროტოკოლების უხეში დარღვევით.
            </li>
            <li className="mb-3">
              <strong>
                ინტერნეტის ან საკომუნიკაციო ინფრასტრუქტურის გლობალური გათიშვა:
              </strong>
              ინტერნეტის ან ძირითადი საკომუნიკაციო არხების ფართომასშტაბიანი,
              არაპროგნოზირებადი და ხანგრძლივი გათიშვა.
            </li>
            <li className="mb-3">
              <strong>ფინანსური ბაზრის კოლაფსი:</strong> გლობალური ან
              რეგიონალური ფინანსური ბაზრების მოულოდნელი და მასშტაბური კოლაფსი,
              რომელიც პირდაპირ გავლენას ახდენს პლატფორმის ლიკვიდურობაზე ან
              საოპერაციო შესაძლებლობებზე და არ არის გამოწვეული პლატფორმის
              მენეჯმენტის გადაწყვეტილებებით.
            </li>
          </ul>
        </span>
        <br />
        <br />
        <span className="block">
          5.10. მხარე, რომლისთვისაც შეუძლებელი გახდა ვალდებულების შესრულება
          ფორს-მაჟორული გარემოებების გამო, ვალდებულია დაუყოვნებლივ წერილობით
          აცნობოს მეორე მხარეს ამ გარემოებებისა და მათი სავარაუდო ხანგრძლივობის
          შესახებ და მიიღოს ყველა გონივრული ზომა ფორს-მაჟორული გარემოებების
          შედეგების შესამცირებლად და ვალდებულებების შესასრულებლად, როგორც კი ეს
          შესაძლებელი გახდება.
        </span>
        <br />
        <span className="block">
          5.11. ფორს-მაჟორული გარემოებების არსებობის პერიოდში, ამ გარემოებებით
          დაზარალებული მხარის ვალდებულებების შესრულების ვადა გადაიწევს ამ
          გარემოებების მოქმედების შესაბამისი ვადით. თუ ფორს მაჟორული გარემოებები
          გაგრძელდება 14 (თოთხმეტ) კალენდარულ დღეზე მეტ ხანს, ნებისმიერ მხარეს
          უფლება ექნება შეწყვიტოს ეს შეთანხმება მეორე მხარისთვის წერილობითი
          შეტყობინების გაგზავნის საფუძველზე. ამ შემთხვევაში, არცერთ მხარეს არ
          დაეკისრება პასუხისმგებლობა ზიანისთვის, რომელიც გამოწვეულია შეთანხმების
          შეწყვეტით.
        </span>
        <h2 className="font-bold mt-6">
          <strong>6. მოქმედების ვადა და შეწყვეტა</strong>
        </h2>
        <br />
        <span className="block">
          6.1. ეს შეთანხმება ძალაში შედის თქვენს მიერ მასზე{" "}
          <strong> დათანხმების (Click-Through)</strong> მომენტიდან და მოქმედებს
          <strong> განუსაზღვრელი ვადით</strong>, სანამ არ მოხდება მისი შეწყვეტა
          ამ წესების შესაბამისად.
        </span>
        <br />
        <span className="block">6.2. შეწყვეტის საფუძვლები:</span>
        <br />
        <span className="block">
          * დაუყოვნებლივ, თუ ერთ-ერთმა მხარემ დაარღვია ნაკისრი ვალდებულება.
        </span>
        <br />
        <span className="block">
          * <strong>WhiteBIT</strong>-ის მიერ ცალმხრივად, დაუყოვნებლივ,
          წინამდებარე შეთანხმების 4.3 პუქნტით განსაზღვრული წესის შესაბამისად.
        </span>
        <br />
        <span className="block">
          * ცალმხრივად, მეორე მხარისათვის
          <strong> წინასწარ, 30 (ოცდაათი) კალენდარული დღით ადრე </strong>
          წერილობითი შეტყობინების გაგზავნის გზით.
        </span>
        <br />
        <span className="block">
          * მხარეთა ორმხრივი წერილობითი შეთანხმებით.
        </span>
        <br />
        <h2 className="font-bold my-4">
          <strong>
            7. კონფიდენციალურობა, პერსონალური მონაცემები და ინტელექტუალური
            საკუთრება
          </strong>
        </h2>
        <br />
        <span className="block mb-4">
          7.1. მხარეებს ეკისრებათ ამ წესების ფარგლებში გაცემული{" "}
          <strong> კონფიდენციალური ინფორმაციის</strong> დაცვის ვალდებულება,
          რომელიც გრძელდება <strong> განუსაზღვრელი ვადით </strong>წინამდებარე
          შეთანხმების შეწყვეტის შემდეგაც.
        </span>
        <span className="block mb-4">
          7.2. კონფიდენციალურ ინფორმაციად ითვლება ნებისმიერი არასაჯარო
          ინფორმაცია, მათ შორის (მაგრამ არა მხოლოდ) იდეები, გეგმები,
          სტრატეგიები, ნოუ-ჰაუ, კომერციული საიდუმლოებები და ინტელექტუალური
          საკუთრების ობიექტები.
        </span>
        <span className="block mb-4">
          7.3. მიმღები მხარე ვალდებულია არ გამოიყენოს ან არ გადასცეს
          კონფიდენციალური ინფორმაცია მესამე პირებს გამცემი მხარის წინასწარი
          წერილობითი თანხმობის გარეშე.
        </span>
        <span className="block mb-4">
          7.4. კლიენტი აცნობიერებს, რომ <strong>Whitepay</strong> პროგრამული
          უზრუნველყოფის გამოყენება არ გულისხმობს მასზე რაიმე უფლების გადაცემას.
          კლიენტი ვალდებულია არ მოახდინოს პროგრამული უზრუნველყოფის მოდიფიკაცია,
          დეკომპილაცია, დერივატული პროგრამის შექმნა, მავნე პროგრამული
          უზრუნველყოფის ჩატვირთვა ან უსაფრთხოების ფარგლების გვერდის ავლა.
        </span>
        <span className="block mb-4">
          7.5. კლიენტი თანახმაა, რომ <strong>WhiteBIT</strong>-მა შეიძლება
          გაამჟღავნოს მისი/მისი თანამშრომლების/მომხმარებლების პერსონალური
          მონაცემები მხოლოდ კანონის მოთხოვნით ან როდესაც ეს აუცილებელია
          მომსახურების გასაწევად.
        </span>
        <h2 className="font-bold my-6">
          <strong>8. გამოყენებული სამართალი და დავის გადაწყვეტა</strong>
        </h2>
        <span className="block">
          8.1. ეს შეთანხმება რეგულირდება და განიმარტება
          <strong> საქართველოს კანონმდებლობის</strong> შესაბამისად.
        </span>
        <br />
        <span className="block">
          8.2. მხარეები ეცდებიან დავის გადაწყვეტას{" "}
          <strong>მოლაპარაკებების</strong> გზით. თუ დავა მისი წარმოშობიდან
          <strong>30 დღის</strong> განმავლობაში ვერ გადაწყდება, იგი
          განსახილველად გადაეცემა <strong>თბილისის საქალაქო სასამართლოს</strong>
          .
        </span>
        <h2 className="font-bold my-6">
          <strong>9. დამატებითი წესები</strong>
        </h2>
        <span className="block">
          9.1. ეს შეთანხმება ასახავს ძირითად შეთანხმებას
          <strong className="px-1">
            დინამიური ინვოისების შექმნისა და ვირტუალური აქტივების
            ურთიერთგადაცვლის მომსახურების გაწევის თაობაზე.
          </strong>
          ნებისმიერი საკითხი, რომელიც არ რეგულირდება ამ დოკუმენტით,
          დარეგულირდება <strong> WhiteBIT </strong>-ის{" "}
          <strong>მომხმარებლის ხელშეკრულებით </strong>
          (https://WhiteBIT.ge/terms) და{" "}
          <strong> Whitepay წესებით და პირობებით </strong>
          (https://Whitepay.ge/terms).
        </span>
        <br />
        <span className="block">
          9.2. კლიენტი თანახმაა, რომ <strong>WhiteBIT</strong> უფლებამოსილია,
          მარკეტინგულ აქტივობებში ახსენოს კლიენტი და გამოიყენოს მისი
          ლოგო/დასახელება მხოლოდ საინფორმაციო მიზნებისთვის.
        </span>
        <br />
        <span className="block">
          9.3. ყველა ოფიციალური შეტყობინება უნდა იყოს წერილობითი ფორმით.
          <strong> WhiteBIT</strong>-ის ოფიციალური ელექტრონული ფოსტაა:
          <strong> legal@WhiteBIT.ge</strong>. კლიენტის ელექტრონული ფოსტის
          მისამართი იქნება ის, რომელიც მითითებულია მისი რეგისტრაციისას.
        </span>
        <br />
        <span className="block">
          9.4. ამ წესებში ცვლილებები შედის ძალაში <strong> WhiteBIT</strong>-ის
          მიერ პლატფორმაზე მათი <strong>გამოქვეყნების </strong>მომენტიდან.
        </span>
      </div>
    ),
  },
];
